import XMarkIcon from "@heroicons/react/24/solid/XMarkIcon";
import { shallow } from "zustand/shallow";

import useYardActionEvents from "@hsl/core/hooks/useYardAnalyticsEvents";
import cx from "@hsl/core/utils/cx";

import { useSidebarContext } from "../../hooks/useSidebarToggle";
import { Translate } from "../../hooks/useTranslation";
import useExplorerStore from "../../store/store";
import Filters from "../Filters";
import { SidebarSection, SidebarSectionTitle } from "../Sidebar";

const FiltersSection = () => {
    const { isFiltering, clearFilters } = useExplorerStore(
        ({ isFiltering, clearFilters }) => ({
            isFiltering,
            clearFilters,
        }),
        shallow,
    );
    const { filterEvent } = useYardActionEvents();
    const { toggleSidebar } = useSidebarContext();
    const handleClearClick = () => {
        filterEvent("clear");
        clearFilters();
    };
    return (
        <SidebarSection
            className="px-4 pb-8"
            title={
                <SidebarSectionTitle className="sticky top-0 z-50 flex items-center justify-between border-b-0 bg-white pt-4 sm:-top-8 sm:pb-2">
                    <span>
                        <Translate>Filters</Translate>{" "}
                        <button
                            className={cx(
                                "hover:text-charcoal text-core-blue ml-2 text-xs underline sm:ml-4",
                                isFiltering ? "visible" : "invisible",
                            )}
                            onClick={handleClearClick}
                        >
                            <Translate>Clear All</Translate>
                        </button>
                    </span>
                    <button
                        className="flex items-center justify-end sm:hidden"
                        onClick={toggleSidebar}
                    >
                        <span className="text-sm">Close</span>
                        <XMarkIcon className="text-charcoal ml-1 h-6 w-6 cursor-pointer" />
                    </button>
                    {/* Hack to have full width border */}
                    <div className="absolute -left-6 bottom-0 h-[1px] min-w-[100vw] bg-gray-300 sm:-left-1" />
                </SidebarSectionTitle>
            }
        >
            <>
                {/* Hack to hide filters when scrolling */}
                <div className="fixed left-0 right-0 top-0 z-[1] hidden h-12 bg-white sm:block" />
                <Filters />
            </>
        </SidebarSection>
    );
};

export default FiltersSection;
